import { render, staticRenderFns } from "./ParentChildMenu.vue?vue&type=template&id=2dd512b0"
import script from "./ParentChildMenu.vue?vue&type=script&lang=js"
export * from "./ParentChildMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports